import {gql} from '@apollo/client';

export const LIKE_SONG_MUTATION = gql`
  mutation likeSong($songId: Int!) {
    likeSong(songId: $songId) {
      likeSongId
    }
  }
`;
